var wallpaperCardsManager = (function (){

    function init(){
        $(document).ready(function (){
            if(!$("section.wallpaper-cards-component").length)
            {
                return
            }

            $("section.wallpaper-cards-component").each(function(){
                var currentCarousel = $(this);
                cardsTextContainers = currentCarousel.find(".single-card-container .text-container");
                cardsCtaContainers = currentCarousel.find(".single-card-container .cta-container");
                var wallpaperCardsCount = currentCarousel.find('.single-card-container').length;              

                //OWL CAROUSEL
                carouselObject = currentCarousel.find(".owl-carousel");
                cardCarousel = carouselObject.owlCarousel({
                navText: [
                    "<i class='fas fa-arrow-left'></i>",
                    "<i class='fas fa-arrow-right'></i>"
                ],
                dots: false,
                center: false,
                nav: false,
                loop: false,
                responsive:{
                    0:{
                        mouseDrag: true && !ENV.isEditmode,
                        items: 1,
                        singleItem: false,
                        dots: false,
                        center: false,
                        stagePadding: 50,
                        margin: 15,
                    },
                    992: {
                        mouseDrag: true,
                        items: 4,
                        margin: 30,
                        stagePadding: 0,
                        nav: wallpaperCardsCount > 4,
                    }
                },
                onInitialized: function (e) {
                    var target = $(e.target);
                    if (target.find('.owl-nav:not(.disabled)').length>0){
                        target.find('.owl-prev').attr('title',LABELS.previous).attr('aria-label',LABELS.previous).removeAttr('role');
                        target.find('.owl-next').attr('title',LABELS.next).attr('aria-label',LABELS.next).removeAttr('role');
                    }
                    setTimeout(()=>{
                        target.on('focusin', '.owl-item', function() {
                            var focusedItem = $(this);
                            if (!focusedItem.hasClass('active')){
                                var index = (focusedItem.index()-2)<0? 0 : focusedItem.index()-2;
                                target.trigger('to.owl.carousel', [index, 1000])
                            }
                        });
                    },200,[target])
                }
            });

            if (cardsTextContainers.length > 1) {
                    maxTextContainerHeight = 0;
                    cardsTextContainers.each(function(){
                        if($(this).height() > maxTextContainerHeight){
                            maxTextContainerHeight = $(this).height()
                        }
                    });
                    cardsTextContainers.height(maxTextContainerHeight);
                    //cardsTextContainers.height()
                }
                if (cardsCtaContainers.length > 0) {
                    maxCtaContainerHeight = 0;
                    cardsCtaContainers.each(function(){
                        if($(this).height() > maxCtaContainerHeight){
                            maxCtaContainerHeight = $(this).height()
                        }
                    });
                    cardsCtaContainers.height(maxCtaContainerHeight);
                    //cardsTextContainers.height()
                }
            })


        
        })
    }


    return {
        init: init
    }
})(jQuery);